<template>
  <div>
    <fieldset :disabled="loading">
      <div class="mb-3">
        <label for="exampleFormControlInput1" class="form-label"
          >Lütfen red gerekçenizi belirtiniz:</label
        >
        <textarea
          ref="description"
          v-model="description"
          class="form-control"
          required
          rows="5"
        ></textarea>
      </div>
      <div class="commands">
        <div class="row">
          <div class="btn-group" role="group">
            <button
              type="button"
              class="btn btn-secondary"
              @click="$emit('cancel')"
            >
              Vazgeç
            </button>
            <button type="button" class="btn btn-danger" @click="decline">
              Reddet
            </button>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>
<script>
export default {
  data() {
    return {
      description: "",
      loading: false
    };
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.$refs.description.focus();
  },
  methods: {
    decline() {
      if (!this.description) {
        this.$izonayAlert("Lütfen red gerekçenizi belirtiniz.").then(() => {  
          setTimeout(() => {
            this.$refs.description.focus();            
          }, 500);       
        })
        return;
      } else {
        this.loading = true;
        this.$emit("decline", this.description);
      }
    }
  }
};
</script>
